import React, { useState, createContext, useEffect, useMemo, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
// import htmlToImage from 'html-to-image';
import { toPng } from 'html-to-image';
import { PDFDocument } from 'pdf-lib';


export const Context = createContext(null);

const ContextProvider = (props) => {
    const location = useLocation();

    // State declarations
    const [sideBar, setSideBar] = useState(false);
    const [acctBar, setAcctBar] = useState(false);
    const [acctDetailsBar, setAcctDetailsBar] = useState(false);
    const [convertBar, setConvertBar] = useState(false);
    const [liveRatesBar, setLiveRatesBar] = useState(false);
    const [confirmConversion, setConfirmConversion] = useState(false);
    const [sendBar, setSendBar] = useState(false);
    const [sendBarFromBeneficiary, setSendBarFromBeneficiary] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);
    const [viewInvoice, setViewInvoice] = useState(false);
    const [viewTransactionDetails, setViewTransactionDetails] = useState(false);
    const [overViewTransactionDetails, setOverViewViewTransactionDetails] = useState(false);
    const [profileEdit, setProfileEdit] = useState(false);
    const [deleteProfile, setDeleteProfile] = useState(false);
    const [deleteInvoice, setDeleteInvoice] = useState(false);
    const [beneficiaryBar, setBeneficiaryBar] = useState(false);
    const [beneficiaryAdded, setBeneficiaryAdded] = useState(false);
    const [createInvoice, setCreateInvoice] = useState(false);
    const [invoiceAdded, setInvoiceAdded] = useState(false);
    const [forms, setForms] = useState(null);
    const [noDelete, setNoDelete] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedTransactionDetails, setSelectedTransactionDetails] = useState(null);
    const [TransactionType, setTransactionType] = useState('account');
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [banks, setBanks] = useState([]);
    const [uniqueFields, setUniqueFields] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [ManuallyInoutedCountry, setManuallyInoutedCountry] = useState('');
    const [manaullySet, setmanaullySet] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingBen, setLoadingBen] = useState(false);
    const [loadingInvoice, setLoadingInvoice] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showPDFContent, setShowPDFContent] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(null);

    const [method, setMethod] = useState('bank')
    const [beneficiaryAcct, setBeneficiaryAcct] = useState(null)
    const [beneficiaryAcctInCrypto, setBeneficiaryAcctInCrypto] = useState(null)
    const [formDatas, setFormDatas] = useState({
        beneficiary: '',
        amount: '',
        note: '',
        currency: ''
    })

    const [cryptoformData, setCryptoFormData] = useState({
        beneficiary: '',
        amount: ''
    })

    const initialFormData = useMemo(() => ({
        bank_name: "",
        bank_account_type: "",
        currency_code: '',
        account_number: "",
        swift_code: "",
        transit_number: "",
        sort_code: "",
        ifsc_code: "",
        bsb_number: "",
        ncc_number: "",
        clabe_number: "",
        bank_code: "",
        branch_code: "",
        cnaps_code: "",
        clearing_code: "",
        iban: "",
        bic_swift: "",
        pix_code: "",
        nuban_code: "",
        country_code: '',
        routing_number: "",
        full_name: "",
        currency: '',
        countryCode: '',
        stateOrProvince: '',
        postalCode: '',
        streetLine1: '',
        streetLine2: '',
        city: '',
    }), []);

    const [formData, setFormData] = useState(initialFormData);

    const currencyLogos = useMemo(() => ({
        USD: 'https://flagcdn.com/w40/us.png',
        ZAR: 'https://flagcdn.com/w40/za.png',
        NGN: 'https://flagcdn.com/w40/ng.png',
        GBP: 'https://flagcdn.com/w40/gb.png',
        CAD: 'https://flagcdn.com/w40/ca.png',
        GHS: 'https://flagcdn.com/w40/gh.png',
        KES: 'https://flagcdn.com/w40/ke.png',
        CNY: 'https://flagcdn.com/w40/cn.png',
        INR: 'https://flagcdn.com/w40/in.png',
        PHP: 'https://flagcdn.com/w40/ph.png',
        PKR: 'https://flagcdn.com/w40/pk.png',
        SEK: 'https://flagcdn.com/w40/se.png',
        CHF: 'https://flagcdn.com/w40/ch.png',
        EUR: 'https://flagcdn.com/w40/eu.png',
        JPY: 'https://flagcdn.com/w40/jp.png',
        AUD: 'https://flagcdn.com/w40/au.png',
        BRL: 'https://flagcdn.com/w40/br.png',
        MXN: 'https://flagcdn.com/w40/mx.png',
        RUB: 'https://flagcdn.com/w40/ru.png',
        NOK: 'https://flagcdn.com/w40/no.png',
        DKK: 'https://flagcdn.com/w40/dk.png',
        SGD: 'https://flagcdn.com/w40/sg.png',
        HKD: 'https://flagcdn.com/w40/hk.png',
        KRW: 'https://flagcdn.com/w40/kr.png',
        AED: 'https://flagcdn.com/w40/ae.png',
        SAR: 'https://flagcdn.com/w40/sa.png',
        TRY: 'https://flagcdn.com/w40/tr.png',
        EGP: 'https://flagcdn.com/w40/eg.png',
    }), []);


    useEffect(() => {
        setAcctBar(false)
        setAcctDetailsBar(false)
        setConvertBar(false)
        setLiveRatesBar(false)
        setConfirmConversion(false)
        setSendBar(false)
        setSendBarFromBeneficiary(false)
        setViewDetails(false)
        setViewInvoice(false)
        setDeleteProfile(false)
        setDeleteInvoice(false)
        setBeneficiaryBar(false)
        setCreateInvoice(false)
    }, [location.pathname]);

    useEffect(() => {
        const savedFile = localStorage.getItem("ProofOfAddress");
        if (savedFile) {
            const fileData = JSON.parse(savedFile);
            // Convert back to a File object
            const blob = new Blob([new Uint8Array(fileData.data)], { type: fileData.type });
            const file = new File([blob], fileData.name, { type: fileData.type });
            setForms(file);
        }
    }, []);

    // Whenever forms changes, save to localStorage
    useEffect(() => {
        if (forms) {
            forms.arrayBuffer().then((buf) => {
                const obj = {
                    name: forms.name,
                    type: forms.type,
                    data: Array.from(new Uint8Array(buf)), // store raw bytes
                };
                localStorage.setItem("ProofOfAddress", JSON.stringify(obj));
            });
        }
    }, [forms]);

    const fetchData = async (endpoint, headers = {}) => {
        const token = localStorage.getItem('token');
        if (!token) return null;

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/${endpoint}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json',
                    ...headers,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                console.error(`Error fetching ${endpoint}:`, data.message || 'Unknown error');
                return null;
            }

            return data;
        } catch (error) {
            console.error(`Fetch error on ${endpoint}:`, error.message);
            return null;
        }
    };

    const fetchAccountsAndWalletData = useCallback(async () => {
        setLoading(true);
        try {
            const accounts = await fetchData('account');
            if (accounts) {
                localStorage.setItem('UserAcctDetails', JSON.stringify(accounts));
                localStorage.setItem('NumberOfUserAcct', accounts.length);

                // const usdAccount = accounts.find(acc => acc.currency === 'USD');
                // localStorage.setItem('accounts', JSON.stringify(usdAccount ? [usdAccount] : []));

                if (accounts && accounts.length > 0) {
                    localStorage.setItem(
                        'selectedCurrency',
                        JSON.stringify({
                            value: accounts[0].currency,
                            label: accounts[0].currency,
                        })
                    );
                } else {
                    localStorage.removeItem('selectedCurrency');
                }
            }

            const wallet = await fetchData('get_wallet_balance');
            if (wallet) localStorage.setItem('WalletBalance', JSON.stringify(wallet));

            const transactions = await fetchData('transactions');
            if (transactions) {

                localStorage.setItem('UserTransactions', JSON.stringify(transactions))
                const pendingTxns = transactions.filter(txn => (txn.payment.status || '').toLowerCase() !== 'completed');

                // If no pending, clear status and stop here
                if (pendingTxns?.length > 0) {
                    await Promise.all(
                        pendingTxns.map(async (txn) => {
                            const paymentId = txn?.payment?.id;
                            if (!paymentId) {
                                return { id: txn.id, status: 'Missing Payment ID' };
                            }

                            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/payments/${paymentId}/get_data`, {
                                method: "GET",
                                headers: { Authorization: `Token ${token}` },
                            });

                            if (!res.ok) {
                                return { id: txn.id, status: 'Error' };
                            }

                            const text = await res.text();
                            if (!text) return { id: txn.id, status: 'Empty' };

                            const data = JSON.parse(text);
                            return { id: txn.id, status: data.status };
                        })
                    );
                }
            }


            const payments = await fetchData('payments');
            if (payments) localStorage.setItem('UserPayments', JSON.stringify(payments));
        } catch (error) {
            console.error('Error fetching accounts, wallet, transactions or payments:', error.message);
        }
        setLoading(false);
    }, [token]);

    const fetchBeneficiaries = useCallback(async () => {
        setLoadingBen(true);
        const beneficiaries = await fetchData('beneficiary');
        if (beneficiaries) {
            localStorage.setItem('UserBeneficiaryDetails', JSON.stringify(beneficiaries));
            localStorage.setItem('NumberOfBeneficiaryAcct', beneficiaries.length);
        }
        setLoadingBen(false);
    }, []);

    const fetchInvoices = useCallback(async () => {
        setLoadingInvoice(true);
        const invoices = await fetchData('invoices');
        if (invoices) {
            localStorage.setItem('UserInvoice', JSON.stringify(invoices));
            localStorage.setItem('NumberOfInvoices', invoices.length);
        }
        setLoadingInvoice(false);
    }, []);

    const fetchAllData = useCallback(async () => {
        setLoading(true);
        setIsDataLoaded(false);

        try {
            const kyc = await fetchData('kyc');
            if (kyc) localStorage.setItem('KYCcreated', kyc.id);

            const profile = await fetchData('profile');
            if (profile) localStorage.setItem('UserProfile', JSON.stringify(profile));

            await fetchAccountsAndWalletData();
            await fetchBeneficiaries();
            await fetchInvoices();

            localStorage.setItem('hasLoadedDataOnce', 'true');
            setIsDataLoaded(true);
        } catch (err) {
            console.error('Failed to fetch all data:', err.message);
            // setIsDataLoaded(false);
        }

        setLoading(false);
    }, [fetchAccountsAndWalletData, fetchBeneficiaries, fetchInvoices]);

    useEffect(() => {
        const timestamp = localStorage.getItem('tokenTimestamp');
        const now = Date.now();
        const TWO_DAYS = 2 * 24 * 60 * 60 * 1000;
        if (timestamp && now - Number(timestamp) > TWO_DAYS) {
            localStorage.clear();
        }
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const showBalance = localStorage.getItem('showBalance');
        if (token && !showBalance) localStorage.setItem('showBalance', false);
    }, []);


    useEffect(() => {
        const token = localStorage.getItem('token');
        const hasLoadedBefore = localStorage.getItem('hasLoadedDataOnce') === 'true';

        if (token && !hasLoadedBefore) {
            fetchAllData();
        } else {
            // Run page-specific fetch on reload
            if (location.pathname.includes('invoices')) {
                fetchInvoices();
            } else if (location.pathname.includes('beneficiaries')) {
                fetchBeneficiaries();
            } else if (location.pathname.includes('home')) {
                fetchAccountsAndWalletData()
            }

            setIsDataLoaded(true);
        }
    }, [fetchAccountsAndWalletData, location.pathname, fetchBeneficiaries, fetchInvoices, fetchAllData]);




    // All handler toggles
    const toggleHandler = (stateSetter) => () => stateSetter(prev => !prev);

    const handleNoDelete = () => {
        setNoDelete(true);
        setTimeout(() => setNoDelete(false), 3000);
    };

    const ref = useRef();

    const generatePDF = async () => {
        const element = ref.current;
        if (!element) return;

        window.scrollTo(0, 0);

        try {
            const dataUrl = await toPng(element, {
                cacheBust: true,
                pixelRatio: 2, // make it super crisp
            });

            const img = new Image();
            img.src = dataUrl;
            await new Promise((res) => (img.onload = res));

            const pdfDoc = await PDFDocument.create();

            // Convert px to pt (PDF uses points; 1pt = 1/72 inch)
            const pxToPt = 0.75; // 1px = 0.75pt
            const imgPtWidth = img.width * pxToPt;
            const imgPtHeight = img.height * pxToPt;

            const page = pdfDoc.addPage([imgPtWidth, imgPtHeight]);
            const pngImage = await pdfDoc.embedPng(dataUrl);

            page.drawImage(pngImage, {
                x: 0,
                y: 0,
                width: imgPtWidth,
                height: imgPtHeight,
            });

            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'invoice.pdf';
            link.click();
        } catch (err) {
            console.error('PDF generation failed:', err);
        }
    };



    const contextValue = {
        initialFormData,
        setForms,
        forms,
        token,
        setToken,
        // UI state handlers
        sideBar,
        setSideBar,
        acctBar,
        acctDetailsBar,
        convertBar,
        confirmConversion,
        liveRatesBar,
        sendBar,
        sendBarFromBeneficiary,
        viewDetails,
        setViewDetails,
        viewInvoice,
        setViewInvoice,
        viewTransactionDetails,
        overViewTransactionDetails,
        profileEdit,
        deleteProfile,
        setDeleteProfile,
        deleteInvoice,
        setDeleteInvoice,
        beneficiaryBar,
        beneficiaryAdded,
        createInvoice,
        invoiceAdded,
        noDelete,
        deleted,
        selectedInvoice,
        selectedTransactionDetails,
        TransactionType,
        formData,
        setFormData,
        banks,
        setBanks,
        uniqueFields,
        setUniqueFields,
        toggle,
        setToggle,
        ManuallyInoutedCountry,
        setManuallyInoutedCountry,
        manaullySet,
        setmanaullySet,
        loading,
        loadingBen,
        loadingInvoice,
        isDataLoaded,
        currencyLogos,
        generatePDF,
        // generatePDF2,
        ref,
        // Handlers
        handleSideBar: toggleHandler(setSideBar),
        handleAcctBar: toggleHandler(setAcctBar),
        handleAcctDetailsBar: toggleHandler(setAcctDetailsBar),
        handleConvertBar: toggleHandler(setConvertBar),
        handleSendBar: toggleHandler(setSendBar),
        handleSendBarFromBeneficiary: toggleHandler(setSendBarFromBeneficiary),
        handleViewDetails: toggleHandler(setViewDetails),
        handleViewInvoice: toggleHandler(setViewInvoice),
        handleViewTransactionDetails: toggleHandler(setViewTransactionDetails),
        handleOverViewTransactionDetails: toggleHandler(setOverViewViewTransactionDetails),
        handleProfileEdit: toggleHandler(setProfileEdit),
        handleDeleteProfile: toggleHandler(setDeleteProfile),
        handleDeleteInvoice: toggleHandler(setDeleteInvoice),
        handleBeneficiaryBar: toggleHandler(setBeneficiaryBar),
        handleAddedBeneficiaries: toggleHandler(setBeneficiaryAdded),
        handleAddedInvoice: toggleHandler(setInvoiceAdded),
        handleCreateInvoice: toggleHandler(setCreateInvoice),
        handleConversion: toggleHandler(setConfirmConversion),
        handleLiveRates: toggleHandler(setLiveRatesBar),
        handleNoDelete,
        handleDeleted: toggleHandler(setDeleted),
        setSelectedInvoice,
        setSelectedTransactionDetails,
        setTransactionType,
        setDeleted,
        fetchAllData,
        fetchAccountsAndWalletData,
        fetchBeneficiaries,
        fetchInvoices,
        setShowModal,
        showModal,
        showPDFContent,
        setShowPDFContent,
        method,
        setMethod,
        beneficiaryAcct,
        setBeneficiaryAcct,
        formDatas,
        setFormDatas,
        cryptoformData,
        setCryptoFormData,
        setBeneficiaryAcctInCrypto,
        beneficiaryAcctInCrypto,
        selectedCurrency,
        setSelectedCurrency
    };

    return <Context.Provider value={contextValue}>{props.children}</Context.Provider>;
};

export default ContextProvider;
